import { MatchClientModel } from '@sport1/types/sportData'
import { LabelProps, TagProps } from '@sport1/types/web'
import React, { FC } from 'react'
import { WidgetTrackingIdentifier } from '@sport1/bets-service-client'
import SportEvent, { SportEventProps } from '@/components/SportEvent'
import useBettingTracking from '@/hooks/useBettingTracking'

type MatchCardItemProps = {
    match: MatchClientModel
    headline: string
    tag: TagProps | LabelProps | undefined
    props?: Partial<SportEventProps>
}

const MatchCardItem: FC<MatchCardItemProps> = ({ match, headline, tag, props }) => {
    const trackingCreation =
        props?.trackingCreation ?? ('inline_nextmatchday-liveticker' as WidgetTrackingIdentifier)
    const { trackBetImpression } = useBettingTracking(trackingCreation)
    const key = `${match.homeTeam?.shortName}_${match.awayTeam?.shortName}_${match.scheduledStartTime}`
    return (
        <SportEvent
            {...props}
            testID={key}
            match={match}
            headline={{
                text: headline,
                imageUrl: tag?.iconUrl ?? '', // use tag image if tag is provided
            }}
            tag={tag}
            // TODO: we can not update bet-service-client because of sport1-components, maybe using S1_WIDGETS like in the App?
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            trackingCreation={props?.trackingCreation ?? 'inline_nextmatchday-liveticker'}
            trackBetImpression={trackBetImpression}
            scope={props?.scope ?? 'ticker'}
            /*trackCardClick={() =>
                trackMatchCardClick?.(matchClientModel, 0, 'card') // TODO: is there some tracking todo?
            }*/
            minify
            forceMobileView
        />
    )
}

export default MatchCardItem
